import { withTranslation } from "react-i18next";

import React from 'react';
import { DashboardHeader } from '../Common/DashboardHeader';
import { Footer, Header } from '../Common';
import { connect } from 'react-redux';
import { sellerChangePassword } from '../../Action/changePassword';
import { withRouter } from 'react-router-dom';
import { SideBar } from '../Common/SideBar';
import SimpleReactValidator from 'simple-react-validator';
class SellerChangePasswod extends React.Component {
    constructor(props) {
        super(props);
        let x = JSON.parse(localStorage.getItem('info'))
        if (x === null || x === '' || x.user_type_id !== 2) {
            alert(this.props.t('2'))
            this.props.history.push('/login/seller');
        };
        this.state = {
            _id: false,
            currentPassword: '',
            newPassword: '',
            newConfirmPassword: '',
        }
        this.validator = new SimpleReactValidator({
            message: {
                currentPassword: 'That is not an email.',
                // // OR
                default: 'Validation has failed!'
                // will override all messages
            },
            autoForceUpdate: this
        });
    };
    componentDidMount() {
        window.scrollTo(0, 0)
    }
    updateValue(type, e) {
        var obj = {};
        obj[type] = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        this.setState(obj);
    }
    handleSubmit(e) {
        e.preventDefault();
        if (this.validator.allValid()) {
            var logged_user = JSON.parse(window.localStorage.getItem('info'));
            if (this.state.newPassword === this.state.newConfirmPassword) {
                let data = {}
                data = {
                    user_id: logged_user.id,
                    password_old: this.state.currentPassword,
                    password_new: this.state.newPassword,
                }
                console.log(data)
                this.props.sellerChangePassword(data, this.props.history);
            } else {
                this.validator.showMessages();
            }
        }
    }
    render() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        //for mobile responsive
        if (isMobile) {
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="container-fluid">
                        <div className="row">
                            {/* <div className="col-md-4 input_name">
                                        <SideBar />
                                    </div> */}
                            <div className="col-md-8">
                                <div className="mt-5 input_name big_font guide_text" style={{ width: '100%', fontSize: '20px' }}>
                                    {this.props.t('7')}
                                </div>
                                <form onSubmit={this.handleSubmit.bind(this)} style={{fontSize:'13px'}}>
                                    <div className="form-group">
                                        <div className="row">
                                            <div className="col-md-3">
                                                <label htmlFor="exampleInputEmail1" className="mt-1">{this.props.t('3')}</label>
                                            </div>
                                            <div className="col-md-1 mt-1 small-hidden">:</div>
                                            <div className="col-md-8">
                                                <div className="">
                                                    <input type="password" class="form-control input_form" value={this.state.currentPassword} onChange={this.updateValue.bind(this, 'currentPassword')} onBlur={() => this.validator.showMessageFor('currentPassword')} />
                                                </div>
                                                <span style={{ color: 'red', fontSize: "12px" }}>{this.validator.message('currentPassword', this.state.currentPassword, 'required|currentPassword|min:8')}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <div className="row">
                                            <div className="col-md-3">
                                                <label htmlFor="exampleInputEmail1" className="mt-1">{this.props.t('4')}</label>
                                            </div>
                                            <div className="col-md-1 mt-1 small-hidden">:</div>
                                            <div className="col-md-8">
                                                <div className="">
                                                    <input type="password" class="form-control input_form" value={this.state.newPassword} onChange={this.updateValue.bind(this, 'newPassword')} onBlur={() => this.validator.showMessageFor('newPassword')} />
                                                </div>
                                                <span style={{ color: 'red', fontSize: "12px" }}>{this.validator.message('newPassword', this.state.newPassword, 'required|newPassword|min:8')}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <div className="row">
                                            <div className="col-md-3">
                                                <label htmlFor="exampleInputEmail1" className="mt-1">{this.props.t('0')}</label>
                                            </div>
                                            <div className="col-md-1 mt-1 small-hidden">:</div>
                                            <div className="col-md-8">
                                                <div className="">
                                                    <input type="password" class="form-control input_form" value={this.state.newConfirmPassword} onChange={this.updateValue.bind(this, 'newConfirmPassword')} onBlur={() => this.validator.showMessageFor('newConfirmPassword')} />
                                                </div>
                                                <span style={{ color: 'red', fontSize: "12px" }}>{this.validator.message('newConfirmPassword', this.state.newConfirmPassword, 'required|newConfirmPassword|min:8')}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="text-center p-3 mt-3" >
                                        <button type="submit" className="btn btn-lg" style={{ backgroundColor: "#7ea9e6", borderColor: "#6290d1", color: '#fff', boxShadow: "#ffffff4d 0px 1px 0px 0px inset" }}>
                                            <span className="fa fa-check"></span>
                                            {this.props.t('9')}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            )
        }
        //for desktop view
        else if (isDesktop) {
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="container-fluid">
                        <div className="container">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-4 input_name">
                                        <SideBar />
                                    </div>
                                    <div className="col-md-8">
                                        <div className="mb-3 input_name big_font guide_text" style={{ width: '100%' }}>
                                            {this.props.t('7')}
                                    </div>
                                        <form onSubmit={this.handleSubmit.bind(this)}>
                                            <div className="form-group">
                                                <div className="row">
                                                    <div className="col-md-3">
                                                        <label htmlFor="exampleInputEmail1" className="mt-1">{this.props.t('3')}</label>
                                                    </div>
                                                    <div className="col-md-1 mt-1">:</div>
                                                    <div className="col-md-8">
                                                        <div className="">
                                                            <input type="password" class="form-control input_form" value={this.state.currentPassword} onChange={this.updateValue.bind(this, 'currentPassword')} onBlur={() => this.validator.showMessageFor('currentPassword')} />
                                                        </div>
                                                        <span style={{ color: 'red', fontSize: "12px" }}>{this.validator.message('currentPassword', this.state.currentPassword, 'required|currentPassword|min:8')}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="form-group">
                                                <div className="row">
                                                    <div className="col-md-3">
                                                        <label htmlFor="exampleInputEmail1" className="mt-1">{this.props.t('4')}</label>
                                                    </div>
                                                    <div className="col-md-1 mt-1">:</div>
                                                    <div className="col-md-8">
                                                        <div className="">
                                                            <input type="password" class="form-control input_form" value={this.state.newPassword} onChange={this.updateValue.bind(this, 'newPassword')} onBlur={() => this.validator.showMessageFor('newPassword')} />
                                                        </div>
                                                        <span style={{ color: 'red', fontSize: "12px" }}>{this.validator.message('newPassword', this.state.newPassword, 'required|newPassword|min:8')}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="form-group">
                                                <div className="row">
                                                    <div className="col-md-3">
                                                        <label htmlFor="exampleInputEmail1" className="mt-1">{this.props.t('0')}</label>
                                                    </div>
                                                    <div className="col-md-1 mt-1">:</div>
                                                    <div className="col-md-8">
                                                        <div className="">
                                                            <input type="password" class="form-control input_form" value={this.state.newConfirmPassword} onChange={this.updateValue.bind(this, 'newConfirmPassword')} onBlur={() => this.validator.showMessageFor('newConfirmPassword')} />
                                                        </div>
                                                        <span style={{ color: 'red', fontSize: "12px" }}>{this.validator.message('newConfirmPassword', this.state.newConfirmPassword, 'required|newConfirmPassword|min:8')}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="text-center p-3 mt-3" >
                                                <button type="submit" className="btn btn-lg  " style={{ backgroundColor: "#7ea9e6", borderColor: "#6290d1", color: '#fff', boxShadow: "#ffffff4d 0px 1px 0px 0px inset" }}>
                                                    <span className="fa fa-check"></span>
                                                    {this.props.t('9')}
                                            </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            )
        }
    }
}
const mapStateToProps = (state) => ({
    sellerChangePassword: state.sellerChangePassword,
    errors: state.errors,
});

SellerChangePasswod = connect(mapStateToProps, { sellerChangePassword })(withRouter(SellerChangePasswod));

export { SellerChangePasswod }


SellerChangePasswod = withTranslation('src_Components_ChangePassword_SellerChangePassword')(SellerChangePasswod);
